import { FlowNodeBaseType, FlowNodeEntity } from '@flowgram.ai/free-layout-editor';

/**
 * 从节点列表中排除分镜组内的子节点，避免弹出节点级菜单。
 */
export function excludeStoryboardGroupChildren(nodes: FlowNodeEntity[]): FlowNodeEntity[] {
  return nodes.filter((node) => !isNodeInStoryboard(node));
}

/**
 * 获取节点所在的群组父节点。
 */
export function getParentGroupNode(node: FlowNodeEntity): FlowNodeEntity | undefined {
  let current = node.parent as FlowNodeEntity | undefined;
  while (current) {
    if (current.flowNodeType === FlowNodeBaseType.GROUP) {
      return current;
    }
    current = current.parent as FlowNodeEntity | undefined;
  }
  return undefined;
}

/**
 * 判断群组节点是否为分镜组。
 *
 * @param {FlowNodeEntity} node - 群组节点
 * @returns {boolean} 是否为分镜组
 */
export function isStoryboardGroupNode(node: FlowNodeEntity): boolean {
  try {
    if (node.flowNodeType !== FlowNodeBaseType.GROUP) {
      return false;
    }
    const containerData = node.toJSON?.()?.data as { groupMode?: string; } | undefined;
    return containerData?.groupMode === 'storyboard';
  } catch {
    return false;
  }
}

/**
 * 判断当前节点是否在分镜组内。
 * 向上查找 GROUP 父节点，检查其 groupMode 是否为 storyboard。
 */
export function isNodeInStoryboard(node: FlowNodeEntity): boolean {
  const parentGroup = getParentStoryboardGroupNode(node);
  return Boolean(parentGroup);
}

/**
 * 获取节点所在的分镜组父节点。
 */
export function getParentStoryboardGroupNode(node: FlowNodeEntity): FlowNodeEntity | undefined {
  const parentGroup = getParentGroupNode(node);
  if (!parentGroup || !isStoryboardGroupNode(parentGroup)) {
    return undefined;
  }
  return parentGroup;
}
